module.exports = __webpack_public_path__ + "img/DE05835.f98a52e5.svg";